<template>
  <div class="text-page">
    <template v-if="!error">
      <div v-if="windowSizeMixin.width > 768 && text.pc_image"
           class="text-page__image">
        <v-lazy-image :srcset="text.pc_image_webp"
                      :src="text.pc_image"
                      :title="createTitleMixin(text.title)"
                      :alt="createAltMixin(text.title)"
                      use-picture>
          <source v-if="text.pc_image_webp"
                  :srcset="text.pc_image_webp"
                  type="image/webp">
        </v-lazy-image>
      </div>
      <div v-else-if="windowSizeMixin.width < 768 && image_mob"
           class="text-page__image">
        <v-lazy-image :srcset="text.mob_image_webp"
                      :src="text.mob_image"
                      :title="createTitleMixin(text.title)"
                      :alt="createAltMixin(text.title)"
                      use-picture>
          <source v-if="text.mob_image_webp"
                  :srcset="text.mob_image_webp"
                  type="image/webp">
        </v-lazy-image>
      </div>
      <!--      <div v-else-if="image" class="text-page__image">-->
      <!--        <v-lazy-image :srcset="text.post_image_webp"-->
      <!--                      :src="text.post_image"-->
      <!--                      :title="createTitleMixin(text.title)"-->
      <!--                      :alt="createAltMixin(text.title)"-->
      <!--                      use-picture>-->
      <!--          <source v-if="text.post_image_webp"-->
      <!--                  :srcset="text.post_image_webp"-->
      <!--                  type="image/webp">-->
      <!--        </v-lazy-image>-->
      <!--      </div>-->
    </template>
    <Breadcrumbs v-if="!isRouteNameMixin('useful-materials-single')"
                 :links="breadCrumbsLinks"/>
    <ErrorView v-if="error"/>
    <div v-else class="container">
      <div class="container-inner" style="max-width: 960px">
        <div v-if="pending" class="page__columns-inner container-inner">
          <div class="page__main-col">
            <BasePreloader/>
          </div>
        </div>
        <div v-else>
          <router-link-modified v-if="!isRouteNameMixin('useful-materials-single')"
                                :to="{name: 'news-page'}"
                                class="text-page__back-btn  base-btn  base-btn--outline-grey  base-btn--small">
            <BaseSvg name="ico-arrow-light"
                     width="0.8rem"
                     height="0.8rem"
                     style="transform: rotate(180deg)"/>
            <span class="tag-btn__text">{{ $tGlobal('To back') }}</span>
          </router-link-modified>
          <h1 class="text-page__title">{{ text.title }}</h1>
          <div class="text-page__under-title-row">
            <time :datetime="text.created_at | formatDateForTimeTag"
                  class="text-page__time">
              {{text.created_at | formatDate}}
            </time>
            <ShareToMessengers :title="windowSizeMixin.width < WINDOW_SIZE_SM ? $tNews('Send:') : $tNews('Send news:')"
                               class="text-page__share-to-messenger"/>
          </div>

<!--          <div class="text-page__inner  _news-body  text">-->
<!--            <h2>Lorem ipsum dolor sit.</h2>-->
<!--            <h3>Lorem ipsum dolor sit.</h3>-->
<!--            <h4>Lorem ipsum dolor sit.</h4>-->
<!--            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet, dolores.</p>-->
<!--            <ul>-->
<!--              <li>Lorem ipsum dolor sit.</li>-->
<!--              <li>Lorem ipsum dolor sit.</li>-->
<!--            </ul>-->

<!--            <ol>-->
<!--              <li>Lorem ipsum dolor sit.</li>-->
<!--              <li>Lorem ipsum dolor sit.</li>-->
<!--            </ol>-->

<!--            <table>-->
<!--              <thead>-->
<!--              <tr>-->
<!--                <th>Lorem ipsum.</th>-->
<!--                <th>Lorem ipsum.</th>-->
<!--              </tr>-->
<!--              </thead>-->
<!--              <tbody>-->
<!--              <tr>-->
<!--                <td>Lorem ipsum.</td>-->
<!--                <td>Lorem ipsum.</td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td>Lorem ipsum.</td>-->
<!--                <td>Lorem ipsum.</td>-->
<!--              </tr>-->
<!--              </tbody>-->
<!--            </table>-->


<!--          </div>-->

          <div ref="contentBody"
               v-html="text.body"
               class="text-page__inner  _news-body  text"/>

          <NewsCarousel v-if="text && text.gallery.length"
                        :slides="text.gallery"
                        :slides-webp="text.gallery_webp"
                        :title="text.title"
                        class="text-page__gallery "/>

          <div class="text-page__navigation">
            <div class="text-page__navigation-item _prev">
              <router-link-modified v-if="text.back_post.slug"
                                    :to="{name: getToName, params:{ newsSlug: text.back_post.slug }}"
                                    class="navigation-inner">
                <div class="navigation-image d-sm-none">
                  <v-lazy-image :srcset="text.back_post.post_image_webp"
                                :src="text.back_post.post_image"
                                :alt="createAltMixin(text.back_post.title)"
                                :title="createTitleMixin(text.back_post.title)"
                                use-picture>
                    <source v-if="text.back_post.post_image_webp"
                            :srcset="text.back_post.post_image_webp"
                            type="image/webp">
                  </v-lazy-image>
                </div>
                <div class="navigation-title">
                  <BaseSvg name="ico-arrow-light"
                           width="0.6rem"
                           height="0.8rem"/>
                  <span class="d-none d-sm-inline-flex">{{ $tNews('Previous') }}</span>
                  <span class="d-sm-none">{{ text.back_post.title }}</span>

                </div>
              </router-link-modified>
            </div>

            <div class="text-page__navigation-item _next">
              <router-link-modified v-if="text.next_post.slug"
                                    :to="{name: getToName, params:{ newsSlug: text.next_post.slug }}"
                                    class="navigation-inner">
                <div class="navigation-title">
                  <span class="d-none d-sm-inline-flex">{{ $tNews('Next') }}</span>
                  <span class="d-sm-none">{{ text.next_post.title }}</span>
                  <BaseSvg name="ico-arrow-light"
                           width="0.6rem"
                           height="0.8rem"/>
                </div>
                <div class="navigation-image d-sm-none">
                  <picture>
                    <source v-if="text.next_post.post_image_webp"
                            :srcset="text.next_post.post_image_webp"
                            type="image/webp">
                    <img :src="text.next_post.post_image"
                         :alt="createAltMixin(text.next_post.title)"
                         :title="createTitleMixin(text.next_post.title)">
                  </picture>
                  <v-lazy-image :srcset="text.next_post.post_image_webp"
                                :src="text.next_post.post_image"
                                :alt="createAltMixin(text.next_post.title)"
                                :title="createTitleMixin(text.next_post.title)"
                                use-picture>
                    <source v-if="text.next_post.post_image_webp"
                            :srcset="text.next_post.post_image_webp"
                            type="image/webp">
                  </v-lazy-image>
                </div>
              </router-link-modified>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="recommendedVacancies.length" class="container-inner full-width pt-16 pb-5 pl-3 pr-3">
      <div class="text-page__recommended-vacancies-title mb-5">{{ $tVacancy('recommended_vacancies') }}</div>

      <div class="text-page__recommended-vacancies-list">
        <VacancyCardSmall
          v-for="item in recommendedVacancies"
          :key="item.ID"
          :vacancy="item"
          class="vacancies-result__list-item  _small"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import {http} from '@/axios';
  import {WINDOW_SIZE_SM} from '@/constants/windowSizes'
  import windowSizeMixin from '@/mixins/windowSizeMixin'
  import globalMetaMixin from '@/mixins/globalMetaMixin'
  import {createOneNewsMicroMarking, deleteOneNewsMicroMarking} from '../helpers/micromarking/newsPage'
  import Breadcrumbs from '@/components/Breadcrumbs'
  import NewsCarousel from '@/components/NewsCarousel'
  import {setMetaRobots} from "@/helpers/metaRobots"
  import ErrorView from '@/components/ErrorView'
  import ShareToMessengers from '@/components/ShareToMessengers'
  import VacancyCardSmall from '../components/vacancyCardSmall/VacancyCardSmall';

  export default {
    mixins: [windowSizeMixin, globalMetaMixin],
    components: {
      Breadcrumbs,
      NewsCarousel,
      ErrorView,
      ShareToMessengers,
      VacancyCardSmall,
    },
    data() {
      return {
        pending: false,
        image: null,
        image_pc: null,
        image_mob: null,
        text: '',
        error: null,
        WINDOW_SIZE_SM,

        recommendedVacancies: [],
      };
    },
    computed: {
      getToName() {
        let toNme
        if (this.isRouteNameMixin('useful-materials-single')) {
          toNme = 'useful-materials-single'
        } else {
          toNme = 'news-single-page'
        }
        return toNme
      },
      newsSlug() {
        return this.$route.params.newsSlug
      },
      breadCrumbsLinks() {
        const links = [{
          href: '/news/',
          name: this.$tHome('News'),
          route: {
            name: 'news-page'
          }
        }]

        if (this.text) {
          if (this.text.title) {
            links.push({
              name: this.text.title
            })
          }
        }

        return links
      }
    },
    watch: {
      $route() {
        this.load()
      }
    },
    created() {
      this.load()
    },
    beforeDestroy() {
      deleteOneNewsMicroMarking();
    },
    methods: {
      load() {
        this.pending = true

        return http.get(`/api/news/${this.newsSlug}`).then(({data}) => {
          this.text = data.data
          this.image = data.data.post_image
          this.image_pc = data.data.pc_image
          this.image_mob = data.data.mob_image

          this.setMetaTitleMixin(this.text.title + ' ' + this.$tMeta('news-meta-title'))
          this.setMetaDescriptionMixin(this.text.title + ' ' + this.$tMeta('news-meta-description'))
          this.setOpenGraph({
            title: this.text.title + ' ' + this.$tMeta('news-meta-title'),
            description: this.text.title + ' ' + this.$tMeta('news-meta-description'),
            image: this.image,
          })
          createOneNewsMicroMarking(data.data)

          if (data.data.index === false) {
            setMetaRobots('noindex, follow')
          }

          if (data?.data?.recommended_vacancies) {
            this.recommendedVacancies = data.data.recommended_vacancies;
          }

          setTimeout(() => this.afterLoad());
        }).catch((error) => {
          this.error = {
            code: error.response.status,
            message: error.response.data && error.response.data.message || error.message
          }
        }).finally(() => {
          this.pending = false
        })
      },
      afterLoad() {
        // TODO temporary don't used
        const dontShow = true;
        if (dontShow) return;

        const { contentBody } = this.$refs;
        if (contentBody) {
          [...contentBody.querySelectorAll('img')].forEach(el => {
            if (el.style.float === 'right') el.style.marginLeft = '1.5rem';
            else if (el.style.float === 'left') el.style.marginRight = '1.5rem';
            else el.style.width = '100%';
          });
        }
      },
    }
  }
</script>

<style>


</style>

